import { render, staticRenderFns } from "./Widget9.vue?vue&type=template&id=bd5029d0&scoped=true"
import script from "./Widget9.vue?vue&type=script&lang=js"
export * from "./Widget9.vue?vue&type=script&lang=js"
import style0 from "./Widget9.vue?vue&type=style&index=0&id=bd5029d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5029d0",
  null
  
)

export default component.exports